<template>
    <div>
        <div class="splash-container">
            <h1 class="splash-title">
                <div id="block-one" class="hatch">naptics</div>
                <div id="block-two" class="stretchLeft">heavy duty</div>
                <div>software</div>
                <div id="block-four" class="stretchRight">engineering</div>
            </h1>
            <div id="splash-image">
                <transition name="fade">
                    <img class="image" :src="imageSource" :key="imageSource"/>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HeadlineBanner',

        data () {
            return {
                splashContainerSet: 1,

                updateInterval: 5000,
                interval: null
            }
        },

        computed: {
            imageSource: function () {
                return '/static/img/main_0' + this.splashContainerSet + '.jpg'
            }
        },

        methods: {
            changeImage: function () {
                this.splashContainerSet = (this.splashContainerSet % 6) + 1
            }
        },
        mounted: function () {
            this.interval = setInterval(function () {
                this.changeImage()
            }.bind(this), this.updateInterval)
        },

        beforeDestroy: function () {
            clearInterval(this.interval)
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/main";
    @import "../styles/animations";

    .fade-enter-active, .fade-leave-active {
        transition: opacity .25s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .splash-container {
        overflow: hidden;
        position: relative;
        height: 700px;
    }

    .splash-title {
        z-index: 10;
        font-size: 100px;
        line-height: 0.85em;
        text-align: center;
        color: white;
        font-family: 'futura-pt', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    #splash-image {
        z-index: 1;
        background-size: cover;
        position: absolute;
        overflow: hidden;
    }

    .image {
        max-width: 100%;
        height: auto;
    }

    #splash-image:after {
        background: url('../assets/overlay-pattern.png') repeat;
        content: '';
        position: absolute;
        top: 0; right: 0;
        bottom: 0; left: 0;
        opacity: 0.5;
    }

    #block-one {
        color: #ff5519;
        line-height: 2em;
    }

    #block-two {
        margin-right: 200px;
    }

    #block-four {
        margin-left: 200px;
    }

</style>



// WEBPACK FOOTER //
// src/components/HeadlineBanner.vue